import React, { useMemo } from 'react';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Stack } from '@mui/material';
import { DataGridPro, GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';

import { Bedbank } from '@luxuryescapes/contract-svc-bedbank';

interface Props {
  data: Array<Bedbank.ListSupplierProperty>;
}

export default function PropertiesTable({ data }: Props) {
  const columns: Array<GridColDef> = useMemo(
    () => [
      {
        field: 'supplierPropertyId',
        headerName: 'Id',
        disableColumnMenu: true,
        flex: 1,
        display: 'flex',
      },
      {
        field: 'supplier',
        headerName: 'Supplier',
        disableColumnMenu: true,
        flex: 1,
        display: 'flex',
      },
      {
        field: 'hotelName',
        headerName: 'Name',
        disableColumnMenu: true,
        flex: 2,
        display: 'flex',
      },
      {
        field: 'countryCode',
        headerName: 'Address',
        disableColumnMenu: true,
        display: 'flex',
        renderCell: ({ row }: GridRenderCellParams) => (
          <Box>
            <Box>
              Country Code: <b>{row.countryCode}</b>
            </Box>
            <Box>{row.address}</Box>
            <Box>Latitude: {row.latitude}</Box>
            <Box>Longitude: {row.longitude}</Box>
          </Box>
        ),
        flex: 2,
      },
      {
        field: 'rating',
        headerName: 'Details',
        disableColumnMenu: true,
        display: 'flex',
        renderCell: ({ row }: GridRenderCellParams) => (
          <Box>
            <Box>
              <Stack direction="row" spacing={0.5}>
                Multi Unit{' '}
                {row.multiUnit ? (
                  <CheckIcon color="success" fontSize="medium" />
                ) : (
                  <CloseIcon color="error" fontSize="medium" />
                )}
              </Stack>
            </Box>
            <Box>
              Star Rating <b>{row.rating}</b>
            </Box>
            <Box>
              Rank <b>{row.rank}</b>
            </Box>
            <Box>
              Guest Rating Count <b>{row.guestRatingCount}</b>
            </Box>
            <Box>
              Guest Rating Overall <b>{row.guestRatingOverall}</b>
            </Box>
            <Box>
              Number Of Rooms <b>{row.numberOfRooms}</b>
            </Box>
            <Box>
              Number Of Images <b>{row.numberOfImages}</b>
            </Box>
          </Box>
        ),
        flex: 2,
      },
    ],
    [],
  );

  return (
    <>
      <DataGridPro
        columns={columns}
        disableRowSelectionOnClick
        disableColumnMenu
        disableColumnSorting
        getRowHeight={() => 'auto'}
        getRowId={(row) => row.supplierPropertyId}
        rows={data}
        rowCount={data.length}
        density="compact"
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
      />
    </>
  );
}
